import React, { Component } from 'react';

class CalendarListSection extends Component {
  render() {
    const { title, subtitle, children, className = '', style, ...props } = this.props;
    const styleProp = {
      position: 'relative',
      paddingLeft: 12,
      paddingRight: 12,
      ...style,
    };

    const classNameProp = `flex-item-fill ${className}`;

    return (
      <div className="flex-container">
        <div className={classNameProp} style={styleProp} {...props}>
          {title && (<h4>
            {title}
          </h4>)}
          {subtitle && (<h5>
            {subtitle}
          </h5>)}
          {children}
        </div>
      </div>
    );
  }
}

export default CalendarListSection;



// WEBPACK FOOTER //
// ./src/app/components/calendar/CalendarListSection.js